export default {
    props: {
        iconPack: String
    },
    data() {
        return {
            newIconPack: this.iconPack || 'fa'
        }
    }
}
